import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import s from './index.module.scss';
import {connect} from 'react-redux';
import mapStateToProps from '../../redux/util';
import {Menu} from 'antd';

const { SubMenu } = Menu;

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: '1_1',
    };
  }

  componentDidMount() {
    // 组件挂载时也要匹配当前路径，设置选中状态
    if (this.props.navs && this.props.navs.array && this.props.navs.array.length > 0) {
      this.getKey(this.props.navs, this.props.props.location.pathname);
    }
  }

  componentWillReceiveProps(next) {
    // console.log(next, 'next in will')
    if (next.navs && next.navs.array && next.navs.array.length > 0) {
      this.getKey(next.navs, next.props.location.pathname);
    }
  }

  setRouteMatchKey(data, path) {
    // console.log(data, path, 'data and path')
    const onlyCnNavs = [//'/private/access-instructions', // '/private/communication-protocols/public-mqtt-json',
      // '/private/air-monitor/access-instructions'
    ];
    const { locale, props } = this.props;
    // console.log(this.props, 'props in setRoute')
    if (locale === 'en' && onlyCnNavs.indexOf(path) > -1) {
      props.history.push({
        pathname: '/introductions',
      });
    }
    data.array && data.array.length > 0 && data.array.forEach(item => {
      if (item.route === path) {
        this.setState({
          current: item.key,
        });
        // console.log(this.state.current, 'current')
      } else {
        item.array && item.array.length > 0 && this.setRouteMatchKey(item, path);
      }
    });
  }

  //获取当前选中key
  getKey(navs, pathname) {
    // console.log(pathname, 'pathnanme')
    navs && navs.array && navs.array.forEach(item => {
      this.setRouteMatchKey(item, pathname);
    });
  }

  handleClick(e) {
    // console.log('click', e)
    this.setState({
      current: e.key,
    });
  }

  render() {
    const { locale } = this.props;
    const width = locale.includes('en') ? 260 : 260;
    const { navs } = this.props;
    const { current } = this.state;
    return (<div className={ s.container } style={ { borderRadius: 5 } }>
      {/* {
        navs.title?<div className={ s.title }>{ navs.title }</div>:null
      } */}

        <Menu
          onClick={ e => this.handleClick(e) }
          style={ { width: width , height:300} }
          defaultOpenKeys={ ['1','2', '3', '3_2', '3_3'] }
          selectedKeys={ [current] }
          mode="inline"
          inlineCollapsed={ false }
          theme="dark"
          onSelect={ () => {
            window.scrollTo(0, 0);
          } }
        >
          { (navs.array && navs.array.length > 0) ? navs.array.map((item, itemIndex) => {
            return (
              <SubMenu
                key={item.key}
                
                title={
                  <div >
                    <div>{item.title}</div>
                    {item.description && <div className={s.description}>{item.description}</div>}
                  </div>
                }
              >
                  { (item.array && item.array.length > 0) ? item.array.map((menuItem, menuIndex) => {
                    if (menuItem.array && menuItem.array.length > 0) {
                      return (<SubMenu key={ menuItem.key } title={ menuItem.title } style={ { marginLeft: 15 } }>
                        { menuItem.array.map((innerItem, index) => {
                          return <Menu.Item key={ innerItem.key }>
                            <Link to={ innerItem.route }>{ innerItem.title }</Link>
                          </Menu.Item>;
                        }) }
                      </SubMenu>);
                    } else {
                      return <Menu.Item key={ menuItem.key } >
                        <Link to={ menuItem.route }>{ menuItem.title }</Link>
                      </Menu.Item>;
                    }
                  }) : null }
              </SubMenu>
            );
          }) : null }
        </Menu>

      </div>);
  }
}


export default connect(mapStateToProps)(Nav);

